import React from 'react'
import {SwitchComponente} from './SwitchComponente'

export default function PermisoSwitch(props) {

    const datos = props.item;
    const setDatos = (valor) => {
        props.handlePermisos(props.index, valor);
    };
    
    
    return (
        <div className=" col-sm-12 col-lg-4 mt-2 mb-2" style={{border:'1px solid black', boxShadow:'0px 0px 0px 1px white'}}>
            <label
                className="form-label fw-semibold text-primary-light text-sm mb-8"
            >
                {props.item.label}
            </label>

            <div className='row'>
                <div className="form-switch switch-primary d-flex justify-content-between px-1 mt-1 mb-1">
                    <SwitchComponente texto={'Ver'} elCheck={Boolean(datos.esVer)} name={'esVer'} datos={datos} setDatos={setDatos} tipo={props.tipo}/>
                    <SwitchComponente texto={'Crear'} elCheck={Boolean(datos.esCrear)} name={'esCrear'} datos={datos} setDatos={setDatos} tipo={props.tipo}/>
                    <SwitchComponente texto={'Editar'} elCheck={Boolean(datos.esEditar)} name={'esEditar'} datos={datos} setDatos={setDatos} tipo={props.tipo}/>
                    <SwitchComponente texto={'Eliminar'} elCheck={Boolean(datos.esEliminar)} name={'esEliminar'} datos={datos} setDatos={setDatos} tipo={props.tipo}/>
                </div>

            </div>
        </div>
    )
}
